import { Injectable } from '@angular/core';
const pdfMake = require('pdfmake/build/pdfmake.js');
const pdfFonts = require('pdfmake/build/vfs_fonts.js');
pdfMake.vfs = pdfFonts.pdfMake.vfs;
import { Cell, Workbook } from 'exceljs';
import * as fs from 'file-saver';
import { HttpClient } from '@angular/common/http';
@Injectable({
  providedIn: 'root',
})
export class ImpresionLiquidacionService {
  constructor() {}

  async crearPDF(
    data: any,
    fechasSemana: any,
    currentPartner: any,
    selectedSemana: any
  ) {
    const logoImage = await this.convertImageToDataURL(
      './assets/images/logAlp.png'
    );
    const logoImage2 = await this.convertImageToDataURL(
      './assets/images/fonAzPdf.png'
    );
    const folio = 1;
    let docDefinition: any = {
      pageMargins: [40, 30, 40, 30], //[left, top, right, bottom]
      content: [
        {
          image: 'logo',
          width: 75,
          absolutePosition: { x: 40, y: 12 },
          opacity: 0.8,
        },
        {
          image: 'logo2',
          width: 680,
          absolutePosition: { x: -5, y: 802.5 },
          opacity: 0.8,
        },
        {
          layout: 'noBorders',
          table: {
            widths: ['100%'],
            heights: [10],
            alignment: 'center',
            body: [
              [
                this.createColumn(
                  'GANADEROS PRODUCTORES DE LECHE PURA, S. A. P. I. DE C. V.',
                  'center',
                  0,
                  true
                ),
              ],
              [
                this.createColumn(
                  'KM. 37.4 AUTOPISTA MÉXICO-QUERÉTARO PARQUE INDUSTRIAL CUAMATLA, C. P. 54730',
                  'center',
                  0,
                  true
                ),
              ],
              [
                this.createColumn(
                  'CUAUTITLAN IZCALLI ESTADO DE MÉXICO, TEL. 899-20-00',
                  'center',
                  0,
                  true
                ),
              ],
              [this.createColumn('RFC. GPL-860521-FW8', 'center', 0, true)],
            ],
          },
        },
        {
          style: 'tableBodyLiquidacion',
          layout: 'noBorders',
          table: {
            widths: [
              '10%',
              '10%',
              '10%',
              '10%',
              '10%',
              '10%',
              '10%',
              '10%',
              '10%',
              '10%',
            ],
            heights: [6, 6, 6, 6, 6, 6, 6, 6, 6, 6],
            headerRows: 1,
            margin: [0, 0, 0, 0],
            body: this.createRows(
              data,
              currentPartner,
              fechasSemana,
              selectedSemana,
              folio
            ),
          },
        },
      ],
      images: {
        logo: logoImage, // Usa la imagen en el contenido del PDF
        logo2: logoImage2,
      },
      styles: {
        boldText: {
          bold: true,
        },
      },
    };
    pdfMake.createPdf(docDefinition).download('ReporteLiquidacion.pdf');
  }

  //****Función para multiples hojas en un pdf */
  async crearPDFs(datas: any, fechasSemana: any, selectedSemana: any) {
    const logoImage = await this.convertImageToDataURL(
      './assets/images/logAlp.png'
    );
    const logoImage2 = await this.convertImageToDataURL(
      './assets/images/fonAzPdf.png'
    );
    for (let i = 0; i < datas.length; i++) {
      var numSoc = datas[i].socio.partnerNumber;
      datas[i] = {
        ...datas[i],
        numSocio: numSoc,
        folio: i + 1,
      };
    }

    for (let i = 0; i < datas.length; i++) {
      var numSoc = datas[i].socio.partnerNumber;
      datas[i] = {
        ...datas[i],
        folio: i + 1,
      };
    }

    let dataReport: any[] = [];
    let auxdataReport: any[] = [];
    let contData = 0;
    var folio = 1;
    datas.forEach((dato: any) => {
      let predataReport: any[] = [];
      predataReport = [
        {
          image: 'logo',
          width: 75,
          absolutePosition: { x: 40, y: 12 },
          opacity: 0.8,
        },
        {
          image: 'logo2',
          width: 680,
          absolutePosition: { x: -5, y: 802.5 },
          opacity: 0.8,
        },
        {
          layout: 'noBorders',
          table: {
            widths: ['100%'],
            heights: [10],
            alignment: 'center',
            body: [
              [
                this.createColumn(
                  'GANADEROS PRODUCTORES DE LECHE PURA, S. A. P. I. DE C. V.',
                  'center',
                  0,
                  true
                ),
              ],
              [
                this.createColumn(
                  'KM. 37.4 AUTOPISTA MÉXICO-QUERÉTARO PARQUE INDUSTRIAL CUAMATLA, C. P. 54730',
                  'center',
                  0,
                  true
                ),
              ],
              [
                this.createColumn(
                  'CUAUTITLAN IZCALLI ESTADO DE MÉXICO, TEL. 899-20-00',
                  'center',
                  0,
                  true
                ),
              ],
              [this.createColumn('RFC. GPL-860521-FW8', 'center', 0, true)],
            ],
          },
        },
        {
          style: 'tableBodyLiquidacion',
          layout: 'noBorders',
          table: {
            widths: [
              '10%',
              '10%',
              '10%',
              '10%',
              '10%',
              '10%',
              '10%',
              '10%',
              '10%',
              '10%',
            ],
            heights: [6, 6, 6, 6, 6, 6, 6, 6, 6, 6],
            headerRows: 1,
            margin: [0, 0, 0, 0],
            body: this.createRows(
              dato,
              dato.socio,
              fechasSemana,
              selectedSemana,
              dato.folio
            ),
          },
        },
      ];
      
      contData = contData + 1;
      if(datas.length != contData){
        predataReport.push({
          text: '',
          pageBreak: 'after', // Agrega un salto de página antes de este contenido
        });
      }
      auxdataReport = predataReport;
      dataReport.push(predataReport);
    });
    let docDefinition: any = {
      pageMargins: [40, 30, 40, 30], //[left, top, right, bottom]
      content: dataReport,
      images: {
        logo: logoImage, // Usa la imagen en el contenido del PDF
        logo2: logoImage2,
      },
      styles: {
        boldText: {
          bold: true,
        },
      },
    };
    pdfMake.createPdf(docDefinition).download('ReporteLiquidacion.pdf');
  }

  private async convertImageToDataURL(imagePath: string): Promise<string> {
    return new Promise<string>((resolve, reject) => {
      const image = new Image();
      image.onload = () => {
        const canvas = document.createElement('canvas');
        canvas.width = image.width;
        canvas.height = image.height;
        const context = canvas.getContext('2d');

        if (context) {
          context.drawImage(image, 0, 0);
          resolve(canvas.toDataURL('image/png'));
        } else {
          reject(new Error('No se pudo obtener el contexto 2D del canvas.'));
        }
      };
      image.onerror = reject;
      image.src = imagePath;
    });
  }

  formatoMiles(numero: any): string {
    if (numero == null) {
      return '0';
    }
    let numeroSinComas = numero.toString().replace(/,/g, '');

    return numeroSinComas.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }
  createRows(
    data: any,
    currentPartner: any,
    fechasSemana: any,
    selectedSemana: any,
    folio: number
  ) {
    let litrosSemana: Array<any> = data.liquidacionDto?.ltPorDia || [];
    let ltrsAutorizados = data.liquidacionDto?.litroAutorizado || [];
    let ltrsEntregados = data.liquidacionDto?.litroEntregados || [];
    let composicion = data.liquidacionDto?.composiciones || [];
    let premios = data.liquidacionDto?.premios || [];
    let percepciones = data.liquidacionDto?.percDeducs || [];
    let sumaImporteExcedente = data.liquidacionDto?.totalLecheEntregado || [];
    let preciosXLitro = data.liquidacionDto?.precioXLitros || [];
    let bodyReport: Array<any> = [];

    bodyReport.push([
      this.createColumn('', 'center', 6),
      {},
      {},
      {},
      {},
      {},
      {},
      this.createColumn('FOLIO', 'right'),
      this.createColumn(folio.toString(), 'center'),
      {},
    ]);

    bodyReport.push([
      this.createColumn('LIQUIDACION SEMANAL DE LECHE', 'center', 10, true),
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
    ]);

    bodyReport.push([
      this.createColumn('', 'center', 6),
      {},
      {},
      {},
      {},
      {},
      this.createColumn('', 'right'),
      this.createColumn('', 'center'),
      {},
      {},
    ]);

    bodyReport.push([
      this.createColumn('PRODUCTOR', 'left', 0, true),
      {},
      this.createColumn('NOMBRE', 'left', 4, true),
      {},
      {},
      {},
      this.createColumn('RANCHO', 'left', 4, true),
      {},
      {},
      {},
    ]);

    bodyReport.push([
      this.createColumn(currentPartner.partnerNumber + '', '', 0),
      {},
      this.createColumn(currentPartner.partnerName, 'left', 4),
      {},
      {},
      {},
      this.createColumn(currentPartner.bussinessName, 'left', 4),
      {},
      {},
      {},
    ]);

    bodyReport.push([
      this.createColumn('DIRECCION', 'left'),
      this.createColumn(
        (
          currentPartner.fisicalAddress +
          ', ' +
          currentPartner.municipality +
          ',  '
        ).toUpperCase(),
        'left',
        5
      ),
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
    ]);

    var semanaReport = '';

    if (selectedSemana < 10) {
      semanaReport = '0' + selectedSemana;
    } else {
      semanaReport = selectedSemana;
    }

    bodyReport.push([
      this.createColumn('SEMANA', 'left', 0),
      this.createColumn(semanaReport, 'left', 0),
      this.createColumn(
        ' DEL   ' +
          this.formatDate(fechasSemana.inicio) +
          '        AL  ' +
          this.formatDate(fechasSemana.fin),
        'left',
        4
      ),
      this.createColumn('', 'left'),
      {},
      {},
      {},
      {},
      {},
      {},
    ]);

    bodyReport.push([{}, {}, {}, {}, {}, {}, {}, {}, {}, {}]);

    bodyReport.push([
      this.createColumn('DIA', 'left'),
      this.createColumn('', 'center', 0),
      this.createColumn('LITROS', 'right'),
      this.createColumn('', 'center', 1),
      {},
      {},
      {},
      {},
      {},
      {},
    ]);

    //genera las filas para los días
    let sumSemanas = 0;
    litrosSemana.forEach((semana: any) => {
      sumSemanas = sumSemanas + semana.litros;

      bodyReport.push([
        this.createColumn(semana.dia, 'left'),
        this.createColumn('', 'left', 0),
        this.createColumn(this.formatNumber1(semana.litros), 'right'),
        this.createColumn('', 'center', 1),
        {},
        {},
        {},
        {},
        {},
        {},
      ]);
    });

    bodyReport.push([
      this.createColumn('* * * TOTAL * * *', 'left', 2, true),
      this.createColumn('', 'left', 0),
      this.createColumn(this.formatNumber1(sumSemanas), 'right', 0),
      this.createColumn('', 'center', 6),
      {},
      {},
      {},
      {},
      {},
      {},
    ]);

    bodyReport.push([{}, {}, {}, {}, {}, {}, {}, {}, {}, {}]);
    bodyReport.push([
      this.createColumn2(
        '________________________________________________________________________________________________________________________________________________________________________________',
        'normal',
        10
      ),
    ]);
    bodyReport.push([{}, {}, {}, {}, {}, {}, {}, {}, {}, {}]);
    //VOLUMENES

    ltrsEntregados.forEach((entrega: any) => {
      bodyReport.push([
        this.createColumn('', 'center', 3),
        {},
        {},
        {},
        ltrsAutorizados.claseA !== 0
          ? this.createColumn('CLASE "A"', 'right', 0, true)
          : {},
        ltrsAutorizados.claseB !== 0
          ? this.createColumn('CLASE "B"', 'right', 0, true)
          : {},
        ltrsAutorizados.claseBPrima !== 0
          ? this.createColumn('CLASE "B PRIMA"', 'right', 0, true)
          : {},
        ltrsAutorizados.claseC !== 0
          ? this.createColumn('CLASE "C"', 'right', 0, true)
          : {},

        entrega.excedentes !== 0
          ? this.createColumn('"EXCEDENTES"', 'right', 0, true, 6)
          : {},

        this.createColumn('SUMA', 'right', 0, true),
      ]);
    });

    bodyReport.push([
      this.createColumn('VOLUMEN LITROS AUTORIZADOS', 'center', 3),
      {},
      {},
      {},
      ltrsAutorizados.claseA !== 0
        ? this.createColumn(
            this.formatNumber(ltrsAutorizados.claseA, 0),
            'right'
          )
        : {},
      ltrsAutorizados.claseB !== 0
        ? this.createColumn(
            this.formatNumber(ltrsAutorizados.claseB, 0),
            'right'
          )
        : {},
      ltrsAutorizados.claseBPrima !== 0
        ? this.createColumn(
            this.formatNumber(ltrsAutorizados.claseBPrima, 0),
            'right'
          )
        : {},
      ltrsAutorizados.claseC !== 0
        ? this.createColumn(
            this.formatNumber(ltrsAutorizados.claseC, 0),
            'right'
          )
        : {},
      this.createColumn('', 'right'),
      this.createColumn('', 'right'),
    ]);

    let sumaEntClaseA: number = 0;
    let sumaEntClaseB: number = 0;
    let sumaEntClaseBP: number = 0;
    let sumaEntClaseC: number = 0;
    let sumaEntExcede: number = 0;
    let sumaEntregaTotal: number = 0;
    let ltsEClaseA: number = 0;
    let ltsEClaseB: number = 0;
    let ltsEClaseBP: number = 0;
    let ltsEClaseC: number = 0;
    let ltsEClaseExc: number = 0;
    let ltsEClaseSuma: number = 0;
    ltrsEntregados.forEach((entrega: any) => {
      sumaEntClaseA = sumaEntClaseA + entrega.claseA;
      sumaEntClaseB = sumaEntClaseB + entrega.claseB;
      sumaEntClaseBP = sumaEntClaseBP + entrega.claseBP;
      sumaEntClaseC = sumaEntClaseC + entrega.claseC;
      sumaEntExcede = sumaEntExcede + entrega.excedentes;
      ltsEClaseA = entrega.claseA;
      ltsEClaseB = entrega.claseB;
      ltsEClaseBP = entrega.claseBPrima;
      ltsEClaseC = entrega.claseC;
      ltsEClaseExc = entrega.excedentes;
      sumaEntregaTotal =
        sumaEntregaTotal +
        (entrega.claseA +
          entrega.claseB +
          entrega.claseBPrima +
          entrega.claseC +
          entrega.excedentes);
      ltsEClaseSuma = sumaEntregaTotal;

      bodyReport.push([
        this.createColumn('VOLUMEN LITROS ENTREGADOS', 'center', 3),
        {},
        {},
        {},
        entrega.claseA !== 0
          ? this.createColumn(this.formatNumber(entrega.claseA, 0), 'right')
          : {},
        entrega.claseB !== 0
          ? this.createColumn(this.formatNumber(entrega.claseB, 0), 'right')
          : {},
        entrega.claseBPrima !== 0
          ? this.createColumn(
              this.formatNumber(entrega.claseBPrima, 0),
              'right'
            )
          : {},
        entrega.claseC !== 0
          ? this.createColumn(this.formatNumber(entrega.claseC, 0), 'right')
          : {},
        entrega.excedentes !== 0
          ? this.createColumn(this.formatNumber(entrega.excedentes, 0), 'right')
          : {},
        this.createColumn(
          this.formatNumber(
            entrega.claseA +
              entrega.claseB +
              entrega.claseBPrima +
              entrega.claseC +
              entrega.excedentes,
            0
          ),
          'right'
        ),
      ]);
    });

    bodyReport.push([{}, {}, {}, {}, {}, {}, {}, {}, {}, {}]);

    bodyReport.push([
      this.createColumn2(
        '________________________________________________________________________________________________________________________________________________________________________________',
        'normal',
        10
      ),
    ]);
    bodyReport.push([{}, {}, {}, {}, {}, {}, {}, {}, {}, {}]);
    let sumaCmpClaseA: number = 0;
    let sumaCmpClaseB: number = 0;
    let sumaCmpClaseBP: number = 0;
    let sumaCmpClaseC: number = 0;
    let sumaCmpExcede: number = 0;
    let sumaCmpTotal: number = 0;
    if (composicion.length > 0) {
      //COMPOSICION
      bodyReport.push([
        this.createColumn('IMPORTES COMPOSICION', 'center', 3, true),
        {},
        {},
        this.createColumn('', 'center', 7),
        {},
        {},
        {},
        {},
        {},
        {},
      ]);
      composicion.forEach((item: any) => {
        sumaCmpClaseA = sumaCmpClaseA + item.impClaseA;
        sumaCmpClaseB = sumaCmpClaseB + item.impClaseB;
        sumaCmpClaseBP = sumaCmpClaseBP + item.impClaseBPrima;
        sumaCmpClaseC = sumaCmpClaseC + item.impClaseC;
        sumaCmpExcede = sumaCmpExcede + item.impExcedente;

        bodyReport.push([
          this.createColumn(item.composicion, 'left', 3),
          {},
          {},
          item.promedio !== 0
            ? this.createColumn(this.formatNumber(item.promedio, 2), 'right')
            : {},
          !preciosXLitro.classAFixed && item.impClaseA != 0
            ? this.createColumn(this.formatNumber(item.impClaseA, 2), 'right')
            : {},
          !preciosXLitro.classBFixed && item.impClaseB != 0
            ? this.createColumn(this.formatNumber(item.impClaseB, 2), 'right')
            : {},
          !preciosXLitro.classBPFixed && item.impClaseBPrima != 0
            ? this.createColumn(
                this.formatNumber(item.impClaseBPrima, 2),
                'right'
              )
            : {},
          !preciosXLitro.classCFixed && item.impClaseC != 0
            ? this.createColumn(this.formatNumber(item.impClaseC, 2), 'right')
            : {},
          !preciosXLitro.classExcessFixed && item.impExcedente != 0
            ? this.createColumn(
                this.formatNumber(item.impExcedente, 2),
                'right'
              )
            : {},
          item.suma !== 0
            ? this.createColumn(this.formatNumber(item.suma, 2), 'right')
            : {},
        ]);
      });
      sumaCmpTotal =
        sumaCmpClaseA +
        sumaCmpClaseB +
        sumaCmpClaseBP +
        sumaCmpClaseC +
        sumaCmpExcede;

      bodyReport.push([
        this.createColumn('SUMA', 'left', 3),
        {},
        {},
        {},
        sumaCmpClaseA !== 0
          ? this.createColumn(this.formatNumber(sumaCmpClaseA, 2), 'right')
          : {},
        sumaCmpClaseB !== 0
          ? this.createColumn(this.formatNumber(sumaCmpClaseB, 2), 'right')
          : {},
        sumaCmpClaseBP !== 0
          ? this.createColumn(this.formatNumber(sumaCmpClaseBP, 2), 'right')
          : {},
        sumaCmpClaseC !== 0
          ? this.createColumn(this.formatNumber(sumaCmpClaseC, 2), 'right')
          : {},

        sumaCmpExcede !== 0
          ? this.createColumn(this.formatNumber(sumaCmpExcede, 2), 'right')
          : {},

        this.createColumn(this.formatNumber(sumaCmpTotal, 2), 'right'),
      ]);
      bodyReport.push([{}, {}, {}, {}, {}, {}, {}, {}, {}, {}]);

      bodyReport.push([
        this.createColumn2(
          '________________________________________________________________________________________________________________________________________________________________________________',
          'normal',
          10
        ),
      ]);
      bodyReport.push([{}, {}, {}, {}, {}, {}, {}, {}, {}, {}]);
    }
    let sumaPremioA: number = 0;
    let sumaPremioB: number = 0;
    let sumaPremioBP: number = 0;
    let sumaPremioC: number = 0;
    let sumaPremioExc: number = 0;
    let sumaPremioTotal: number = 0;
    if (
      premios.length > 0 &&
      (!preciosXLitro.classAFixed ||
        !preciosXLitro.classBFixed ||
        !preciosXLitro.classBPFixed ||
        !preciosXLitro.classCFixed ||
        !preciosXLitro.classExcessFixed)
    ) {
      //PREMIOS
      bodyReport.push([
        this.createColumn('* * * PREMIOS * * *', 'center', 3, true),
        {},
        {},
        this.createColumn('INDICE', 'right', 0, true),
        this.createColumn('', 'center', 6),
        {},
        {},
        {},
        {},
        {},
      ]);

      bodyReport.push([{}, {}, {}, {}, {}, {}, {}, {}, {}, {}]);

      premios.forEach((premio: any) => {
        const sumatoria: number =
          premio.impClaseA +
          premio.impClaseB +
          premio.impClaseBPrima +
          premio.impClaseC +
          premio.impExcedente;
        sumaPremioA = sumaPremioA + premio.impClaseA;
        sumaPremioB = sumaPremioB + premio.impClaseB;
        sumaPremioBP = sumaPremioBP + premio.impClaseBPrima;
        sumaPremioC = sumaPremioC + premio.impClaseC;
        sumaPremioExc = sumaPremioExc + premio.impExcedente;
        sumaPremioTotal = sumaPremioTotal + sumatoria;

        if (
          !preciosXLitro.classAFixed ||
          !preciosXLitro.classBFixed ||
          !preciosXLitro.classBPFixed ||
          !preciosXLitro.classCFixed ||
          !preciosXLitro.classExcessFixed || premio.premio == 'PREMIO DE FIDELIDAD'
        ) {
          bodyReport.push([
            this.createColumn(premio.premio, 'left', 3),
            {},
            {},
            this.createColumn(this.formatNumber(premio.promedio, 5), 'right'),
            // C A
            (!preciosXLitro.classAFixed && premio.impClaseA|| premio.premio == 'PREMIO DE FIDELIDAD') != 0
              ? this.createColumn(
                  this.formatNumber(premio.impClaseA, 2),
                  'right'
                )
              : {},
            // C B
            (!preciosXLitro.classBFixed|| premio.premio == 'PREMIO DE FIDELIDAD') &&
            premio.impClaseB != 0 &&
            premio.premio != 'PREMIO POR ESTIMULO' &&
            premio.premio != 'PREMIO DE LEALTAD Y CONTINUIDAD'
              ? this.createColumn(
                  this.formatNumber(premio.impClaseB, 2),
                  'right'
                )
              : {},
            // C BP
            (!preciosXLitro.classBPFixed|| premio.premio == 'PREMIO DE FIDELIDAD') &&
            premio.impClaseBPrima != 0 &&
            premio.premio != 'PREMIO POR ESTIMULO' &&
            premio.premio != 'PREMIO DE LEALTAD Y CONTINUIDAD'
              ? this.createColumn(
                  this.formatNumber(premio.impClaseBPrima, 2),
                  'right'
                )
              : {},
            // C C
            (!preciosXLitro.classCFixed|| premio.premio == 'PREMIO DE FIDELIDAD') &&
            premio.impClaseC != 0 &&
            premio.premio != 'PREMIO POR ESTIMULO' &&
            premio.premio != 'PREMIO DE LEALTAD Y CONTINUIDAD'
              ? this.createColumn(
                  this.formatNumber(premio.impClaseC, 2),
                  'right'
                )
              : {},
            // C EXCEDENTE
            (!preciosXLitro.classExcessFixed || premio.premio == 'PREMIO DE FIDELIDAD') &&
            premio.impExcedente != 0 &&
            premio.premio != 'PREMIO POR ESTIMULO' &&
            premio.premio != 'PREMIO DE LEALTAD Y CONTINUIDAD'
              ? this.createColumn(
                  this.formatNumber(premio.impExcedente, 2),
                  'right'
                )
              : {},
            this.createColumn(this.formatNumber(sumatoria, 2), 'right'),
          ]);
        }
      });

      bodyReport.push([{}, {}, {}, {}, {}, {}, {}, {}, {}, {}]);

      bodyReport.push([
        this.createColumn('SUMA', 'center', 3),
        {},
        {},
        {},
        sumaPremioA !== 0
          ? this.createColumn(this.formatNumber(sumaPremioA), 'right')
          : {},
        sumaPremioB !== 0
          ? this.createColumn(this.formatNumber(sumaPremioB), 'right')
          : {},
        sumaPremioBP !== 0
          ? this.createColumn(this.formatNumber(sumaPremioBP), 'right')
          : {},
        sumaPremioC !== 0
          ? this.createColumn(this.formatNumber(sumaPremioC), 'right')
          : {},
        sumaPremioExc !== 0
          ? this.createColumn(this.formatNumber(sumaPremioExc), 'right')
          : {},
        sumaPremioTotal !== 0
          ? this.createColumn(this.formatNumber(sumaPremioTotal), 'right')
          : {},
      ]);
    }

    var sumImpTotalLecheEntrega = 0;

    const importeALecheEntregada = preciosXLitro.classAFixed
      ? ltrsEntregados[0].claseA * preciosXLitro.classPriceA
      : sumaCmpClaseA + sumaPremioA;
    const importeBLecheEntregada = preciosXLitro.classBFixed
      ? ltrsEntregados[0].claseB * preciosXLitro.classPriceB
      : sumaCmpClaseB + sumaPremioB;
    const importeBPLecheEntregada = preciosXLitro.classBPFixed
      ? ltrsEntregados[0].claseBPrima * preciosXLitro.classPriceBPlus
      : sumaCmpClaseBP + sumaPremioBP;
    const importeCLecheEntregada = preciosXLitro.classCFixed
      ? ltrsEntregados[0].claseC * preciosXLitro.classPriceC
      : sumaCmpClaseC + sumaPremioC;
    const importeExcLecheEntregada = preciosXLitro.classExcessFixed
      ? ltrsEntregados[0].excedentes * preciosXLitro.excessPrice
      : sumaCmpExcede + sumaPremioExc;

    sumImpTotalLecheEntrega =
      importeALecheEntregada +
      importeBLecheEntregada +
      importeBPLecheEntregada +
      importeCLecheEntregada +
      importeExcLecheEntregada;

    bodyReport.push([
      this.createColumn('IMPORTE TOTAL LECHE ENTREGADA', 'center', 3),
      {},
      {},
      {},
      ltrsEntregados[0].claseA > 0
        ? this.createColumn(
            this.formatNumber(importeALecheEntregada, 2),
            'right'
          )
        : {},
      ltrsEntregados[0].claseB > 0
        ? this.createColumn(
            this.formatNumber(importeBLecheEntregada, 2),
            'right'
          )
        : {},
      ltrsEntregados[0].claseBPrima > 0
        ? this.createColumn(
            this.formatNumber(importeBPLecheEntregada, 2),
            'right'
          )
        : {},
      ltrsEntregados[0].claseC > 0
        ? this.createColumn(
            this.formatNumber(importeCLecheEntregada, 2),
            'right'
          )
        : {},
      ltrsEntregados[0].excedentes > 0
        ? this.createColumn(
            this.formatNumber(importeExcLecheEntregada, 2),
            'right'
          )
        : {},

      sumImpTotalLecheEntrega !== 0
        ? this.createColumn(
            this.formatNumber(sumImpTotalLecheEntrega, 2),
            'right'
          )
        : {},
    ]);

    const costoTotalClaseA: number = preciosXLitro.classPriceA;
    const costoTotalClaseB: number = preciosXLitro.classPriceB;
    const costoTotalClaseBP: number = preciosXLitro.classPriceBPlus;
    const costoTotalClaseC: number = preciosXLitro.classPriceC;
    const costoTotalExcede: number = preciosXLitro.excessPrice;
    const costoTotalLitro: number =
      (costoTotalClaseA +
        costoTotalClaseB +
        costoTotalClaseBP +
        costoTotalClaseC +
        costoTotalExcede) /
      sumaEntregaTotal;

    bodyReport.push([
      this.createColumn('$/LT.', 'center', 3),
      {},
      {},
      {},
      !isNaN(preciosXLitro.classPriceA) && preciosXLitro.classPriceA != 0
        ? this.createColumn(
            this.formatNumber(preciosXLitro.classPriceA, 5),
            'right'
          )
        : {},
      !isNaN(preciosXLitro.classPriceB) && preciosXLitro.classPriceB != 0
        ? this.createColumn(
            this.formatNumber(preciosXLitro.classPriceB, 5),
            'right'
          )
        : {},
      !isNaN(preciosXLitro.classPriceBPlus) &&
      preciosXLitro.classPriceBPlus != 0
        ? this.createColumn(
            this.formatNumber(preciosXLitro.classPriceBPlus, 5),
            'right'
          )
        : {},
      !isNaN(preciosXLitro.classPriceC) && preciosXLitro.classPriceC != 0
        ? this.createColumn(
            this.formatNumber(preciosXLitro.classPriceC, 5),
            'right'
          )
        : {},

      !isNaN(preciosXLitro.excessPrice) && preciosXLitro.excessPrice != 0
        ? this.createColumn(
            this.formatNumber(preciosXLitro.excessPrice, 5),
            'right'
          )
        : {},

      !isNaN(sumImpTotalLecheEntrega / ltsEClaseSuma)
        ? this.createColumn(
            this.formatNumber(sumImpTotalLecheEntrega / ltsEClaseSuma, 5),
            'right'
          )
        : {},
    ]);
    bodyReport.push([{}, {}, {}, {}, {}, {}, {}, {}, {}, {}]);

    bodyReport.push([
      this.createColumn2(
        '________________________________________________________________________________________________________________________________________________________________________________',
        'normal',
        10
      ),
    ]);
    bodyReport.push([{}, {}, {}, {}, {}, {}, {}, {}, {}, {}]);

    //PERCEPCIONES
    bodyReport.push([
      this.createColumn('* * * PERCEPCIONES * * *', 'center', 3, true),
      {},
      {},
      this.createColumn('LITROS', 'right'),
      this.createColumn('VALOR LT.', 'right'),
      this.createColumn('', 'center', 4),
      {},
      {},
      {},
      this.createColumn('', 'center'),
    ]);

    bodyReport.push([{}, {}, {}, {}, {}, {}, {}, {}, {}, {}]);

    let totalP077: number = 0;
    let totalP109: number = 0;
    percepciones.sort((a: any, b: any) => {
      return b.resultado - a.resultado;
    });

    percepciones.forEach((perDeduc: any) => {
      if (perDeduc.tipo == 'P') {
        bodyReport.push([
          this.createColumn('P' + perDeduc.clave + ' '  + perDeduc.nombre, 'left', 3),
          {},
          {},
          perDeduc.litros != 0
            ? this.createColumn(this.formatNumber(perDeduc.litros, 0), 'right')
            : '',
          perDeduc.valorLitro != 0
            ? this.createColumn(
                this.formatNumber(perDeduc.valorLitro, 2),
                'right'
              )
            : '',
          this.createColumn('', 'center', 4),
          {},
          {},
          {},
          this.createColumn(this.formatNumber(perDeduc.resultado, 2), 'right'),
        ]);
        sumImpTotalLecheEntrega += perDeduc.resultado;
      }
    });

    bodyReport.push([{}, {}, {}, {}, {}, {}, {}, {}, {}, {}]);

    bodyReport.push([
      this.createColumn('* * * TOTAL * * *', 'left', 3, true),
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      this.createColumn(this.formatNumber(sumImpTotalLecheEntrega, 2), 'right'),
    ]);

    bodyReport.push([
      this.createColumn2(
        '________________________________________________________________________________________________________________________________________________________________________________',
        'normal',
        10
      ),
    ]);
    bodyReport.push([{}, {}, {}, {}, {}, {}, {}, {}, {}, {}]);

    //DEDUCCIONES
    bodyReport.push([
      this.createColumn('* * * DEDUCCIONES * * *', 'center', 3, true),
      {},
      {},
      this.createColumn('LITROS', 'right'),
      this.createColumn('VALOR LT.', 'right'),
      this.createColumn('', 'center', 4),
      {},
      {},
      {},
      this.createColumn('', 'center'),
    ]);

    bodyReport.push([{}, {}, {}, {}, {}, {}, {}, {}, {}, {}]);

    let totalDeducciones: number = 0;
    percepciones.forEach((perDeduc: any) => {
      if (perDeduc.tipo == 'D' && perDeduc.acumulados) {
        if (parseFloat(perDeduc.resultado) != 0) {
          perDeduc.valorLitro = parseFloat(perDeduc.valorLitro);
        }
        totalDeducciones = totalDeducciones + Math.abs(perDeduc.resultado);

        bodyReport.push([
          this.createColumn(
            'D' + perDeduc.clave + ' '  + perDeduc.nombre + ' ' + (perDeduc.factura || ''),
            'left',
            3
          ),
          {},
          {},
          perDeduc.litros != 0
            ? this.createColumn(this.formatNumber(perDeduc.litros, 0), 'right')
            : '',
          perDeduc.valorLitro != 0
            ? this.createColumn(
                this.formatNumber(perDeduc.valorLitro, 2),
                'right'
              )
            : '',
          this.createColumn('', 'center', 4),
          {},
          {},
          {},
          this.createColumn(this.formatNumber(perDeduc.resultado, 2), 'right'),
        ]);
      }

    });
    sumImpTotalLecheEntrega -= totalDeducciones;

    bodyReport.push([
      this.createColumn('* * * TOTAL * * *', 'left', 3, true),
      {},
      {},
      this.createColumn('', 'center', 6),
      {},
      {},
      {},
      {},
      {},
      this.createColumn(this.formatNumber(totalDeducciones), 'right'),
    ]);

    bodyReport.push([{}, {}, {}, {}, {}, {}, {}, {}, {}, {}]);
    bodyReport.push([{}, {}, {}, {}, {}, {}, {}, {}, {}, {}]);

    bodyReport.push([
      this.createColumn('IMPORTE TOTAL LIQUIDACION DE LECHE', 'center', 3),
      {},
      {},
      this.createColumn('', 'center', 6),
      {},
      {},
      {},
      {},
      {},
      this.createColumn(this.formatNumber(sumImpTotalLecheEntrega), 'right'),
    ]);

    bodyReport.push([
      this.createColumn('$/LT.', 'center', 3),
      {},
      {},
      this.createColumn('', 'center', 6),
      {},
      {},
      {},
      {},
      {},
      this.createColumn(
        this.formatNumber(sumImpTotalLecheEntrega / sumaEntregaTotal, 5),
        'right'
      ),
    ]);

    bodyReport.push([{}, {}, {}, {}, {}, {}, {}, {}, {}, {}]);
    // OTRAS DEDUCCIONES
    let totalOtrasDeducciones = 0;
    percepciones.forEach((perDeduc: any) => {
      if (perDeduc.tipo == 'D' && !perDeduc.acumulados) {
        if (parseFloat(perDeduc.resultado) != 0) {
          perDeduc.valorLitro = parseFloat(perDeduc.valorLitro);
        }
        totalOtrasDeducciones = totalOtrasDeducciones + Math.abs(perDeduc.resultado);

        bodyReport.push([
          this.createColumn(
            'D' + perDeduc.clave + ' ' + perDeduc.nombre + ' ' + (perDeduc.factura || ''),
            'left',
            3
          ),
          {},
          {},
          perDeduc.litros != 0
            ? this.createColumn(this.formatNumber(perDeduc.litros, 0), 'right')
            : '',
          perDeduc.valorLitro != 0
            ? this.createColumn(
                this.formatNumber(perDeduc.valorLitro, 2),
                'right'
              )
            : '',
          this.createColumn('', 'center', 4),
          {},
          {},
          {},
          this.createColumn(this.formatNumber(perDeduc.resultado, 2), 'right'),
        ]);
      }
    });
    sumImpTotalLecheEntrega -= totalOtrasDeducciones;
    bodyReport.push([{}, {}, {}, {}, {}, {}, {}, {}, {}, {}]);
    if(totalOtrasDeducciones != 0){
      bodyReport.push([
        this.createColumn('* * * TOTAL * * * ------>', 'left', 3, true),
        {},
        {},
        this.createColumn('', 'center', 6),
        {},
        {},
        {},
        {},
        {},
        this.createColumn(this.formatNumber(totalOtrasDeducciones), 'right'),
      ]);
    }

    bodyReport.push([{}, {}, {}, {}, {}, {}, {}, {}, {}, {}]);

    bodyReport.push([
      this.createColumn('* * * NETO A PAGAR * * * ------>', 'left', 3, true),
      {},
      {},
      this.createColumn('', 'center', 6),
      {},
      {},
      {},
      {},
      {},
      this.createColumn(this.formatNumber(sumImpTotalLecheEntrega), 'right'),
    ]);

    bodyReport.push([
      {},
      {},
      {},
      {},
      this.createColumn('AUTORIZADO', 'right'),
      this.createColumn('ENTREGADO', 'right'),
      this.createColumn('%', 'center'),
      {},
      {},
      {},
    ]);

    bodyReport.push([
      this.createColumn('* * * % CUMPLIMIENTO CONTRATO * * *', 'left', 3, true),
      {},
      {},
      {},
      this.createColumn(
        this.formatNumber(data.liquidacionDto.cumplimientoContrato.autorizad,0),
        'right'
      ),
      this.createColumn(
        this.formatNumber(data.liquidacionDto.cumplimientoContrato.entregado, 0),
        'right'
      ),
      this.createColumn(
        data.liquidacionDto.cumplimientoContrato.porcentaje,
        'center'
      ),
      {},
      {},
      this.createColumn('', 'center'),
    ]);

    return bodyReport;
  }

  createRowsMultiple(
    data: any,
    currentPartner: any,
    fechasSemana: any,
    selectedSemana: any
  ) {
    let litrosSemana: Array<any> = data?.ltPorDia || [];
    let ltrsAutorizados = data?.litroAutorizado || [];
    let ltrsEntregados = data?.litroEntregados[0] || [];
    let composicion = data?.composiciones || [];
    let premios = data?.premios || [];
    let percepciones = data?.percDeducs || [];
    let sumaImporteExcedente = data?.totalLecheEntregado || [];
    let preciosXLitro = data?.precioXLitros || [];
    let bodyReport: Array<any> = [];
    bodyReport.push([{}, {}, {}, {}, {}, {}, {}, {}, {}, {}]);
    bodyReport.push([
      this.createColumn('', 'center', 6),
      {},
      {},
      {},
      {},
      {},
      {},
      this.createColumn('FOLIO', 'right'),
      this.createColumn(data.liquidacionDto?.liquidacionId, 'center'),
      {},
    ]);

    bodyReport.push([
      this.createColumn('LIQUIDACION SEMANAL DE LECHE', 'center', 10, true),
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
    ]);

    bodyReport.push([
      this.createColumn('', 'center', 6),
      {},
      {},
      {},
      {},
      {},
      this.createColumn('', 'right'),
      this.createColumn('', 'center'),
      {},
      {},
    ]);

    bodyReport.push([
      this.createColumn('PRODUCTOR', 'left', 0, true),
      {},
      this.createColumn('NOMBRE', 'left', 4, true),
      {},
      {},
      {},
      this.createColumn('RANCHO', 'left', 4, true),
      {},
      {},
      {},
    ]);

    bodyReport.push([
      this.createColumn(currentPartner.partnerNumber + '', '', 0),
      {},
      this.createColumn(currentPartner.partnerName, 'left', 4),
      {},
      {},
      {},
      this.createColumn(currentPartner.bussinessName, 'left', 4),
      {},
      {},
      {},
    ]);

    bodyReport.push([
      this.createColumn('DIRECCION', 'left'),
      this.createColumn(
        (
          currentPartner.fisicalAddress +
          ', ' +
          currentPartner.municipality +
          ',  ' +
          currentPartner.nombreEstado
        ).toUpperCase(),
        'left',
        5
      ),
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
    ]);

    bodyReport.push([
      this.createColumn('SEMANA', 'left', 0),
      this.createColumn(selectedSemana, 'left', 0),
      this.createColumn(
        ' DEL ' + fechasSemana.inicio.toLocaleDateString('es-MX'),
        'left'
      ),
      this.createColumn(
        ' AL ' + fechasSemana.fin.toLocaleDateString('es-MX'),
        'left'
      ),
      {},
      {},
      {},
      {},
      {},
      {},
    ]);

    bodyReport.push([{}, {}, {}, {}, {}, {}, {}, {}, {}, {}]);

    bodyReport.push([
      this.createColumn('DIA', 'left'),
      this.createColumn('', 'center', 0),
      this.createColumn('LITROS', 'right'),
      this.createColumn('', 'center', 1),
      {},
      {},
      {},
      {},
      {},
      {},
    ]);

    //genera las filas para los días
    let sumSemanas = 0;
    litrosSemana.forEach((semana: any) => {
      sumSemanas = sumSemanas + semana.litros;

      bodyReport.push([
        this.createColumn(semana.dia, 'left'),
        this.createColumn('', 'left', 0),
        this.createColumn(this.formatNumber1(semana.litros), 'right'),
        this.createColumn('', 'center', 1),
        {},
        {},
        {},
        {},
        {},
        {},
      ]);
    });

    bodyReport.push([
      this.createColumn('* * * TOTAL * * *', 'left', 2, true),
      this.createColumn('', 'left', 0),
      this.createColumn(this.formatNumber1(sumSemanas), 'right', 0),
      this.createColumn('', 'center', 6),
      {},
      {},
      {},
      {},
      {},
      {},
    ]);

    bodyReport.push([{}, {}, {}, {}, {}, {}, {}, {}, {}, {}]);
    bodyReport.push([
      this.createColumn2(
        '________________________________________________________________________________________________________________________________________________________________________________',
        'normal',
        10
      ),
    ]);
    bodyReport.push([{}, {}, {}, {}, {}, {}, {}, {}, {}, {}]);
    //VOLUMENES

    ltrsEntregados.forEach((entrega: any) => {
      bodyReport.push([
        this.createColumn('', 'center', 3),
        {},
        {},
        {},
        this.createColumn('CLASE "A"', 'right', 0, true),
        this.createColumn('CLASE "B"', 'right', 0, true),
        this.createColumn('CLASE "B PRIMA"', 'right', 0, true),
        this.createColumn('CLASE "C"', 'right', 0, true),

        entrega.excedentes !== 0
          ? this.createColumn('"EXCEDENTES"', 'right', 0, true, 6)
          : {},

        this.createColumn('SUMA', 'right', 0, true),
      ]);
    });

    bodyReport.push([
      this.createColumn('VOLUMEN LITROS AUTORIZADOS', 'center', 3),
      {},
      {},
      {},
      this.createColumn(this.formatNumber(ltrsAutorizados.claseA, 0), 'right'),
      this.createColumn(this.formatNumber(ltrsAutorizados.claseB, 0), 'right'),
      this.createColumn(
        this.formatNumber(ltrsAutorizados.claseBPrima, 0),
        'right'
      ),
      this.createColumn(this.formatNumber(ltrsAutorizados.claseC, 0), 'right'),
      this.createColumn('', 'right'),
      this.createColumn('', 'right'),
    ]);

    let sumaEntClaseA: number = 0;
    let sumaEntClaseB: number = 0;
    let sumaEntClaseBP: number = 0;
    let sumaEntClaseC: number = 0;
    let sumaEntExcede: number = 0;
    let sumaEntregaTotal: number = 0;
    let ltsEClaseA: number = 0;
    let ltsEClaseB: number = 0;
    let ltsEClaseBP: number = 0;
    let ltsEClaseC: number = 0;
    let ltsEClaseExc: number = 0;
    let ltsEClaseSuma: number = 0;
    ltrsEntregados.forEach((entrega: any) => {
      sumaEntClaseA = sumaEntClaseA + entrega.claseA;
      sumaEntClaseB = sumaEntClaseB + entrega.claseB;
      sumaEntClaseBP = sumaEntClaseBP + entrega.claseBP;
      sumaEntClaseC = sumaEntClaseC + entrega.claseC;
      sumaEntExcede = sumaEntExcede + entrega.excedentes;
      ltsEClaseA = entrega.claseA;
      ltsEClaseB = entrega.claseB;
      ltsEClaseBP = entrega.claseBPrima;
      ltsEClaseC = entrega.claseC;
      ltsEClaseExc = entrega.excedentes;
      sumaEntregaTotal =
        sumaEntregaTotal +
        (entrega.claseA +
          entrega.claseB +
          entrega.claseBPrima +
          entrega.claseC +
          entrega.excedentes);
      ltsEClaseSuma = sumaEntregaTotal;

      bodyReport.push([
        this.createColumn('VOLUMEN LITROS ENTREGADOS', 'center', 3),
        {},
        {},
        {},
        this.createColumn(this.formatNumber(entrega.claseA, 0), 'right'),
        this.createColumn(this.formatNumber(entrega.claseB, 0), 'right'),
        this.createColumn(this.formatNumber(entrega.claseBPrima, 0), 'right'),
        this.createColumn(this.formatNumber(entrega.claseC, 0), 'right'),
        entrega.excedentes !== 0
          ? this.createColumn(this.formatNumber(entrega.excedentes, 2), 'right')
          : {},
        this.createColumn(
          this.formatNumber(
            entrega.claseA +
              entrega.claseB +
              entrega.claseBPrima +
              entrega.claseC +
              entrega.excedentes,
            0
          ),
          'right'
        ),
      ]);
    });

    bodyReport.push([{}, {}, {}, {}, {}, {}, {}, {}, {}, {}]);
    bodyReport.push([
      this.createColumn2(
        '________________________________________________________________________________________________________________________________________________________________________________',
        'normal',
        10
      ),
    ]);
    bodyReport.push([{}, {}, {}, {}, {}, {}, {}, {}, {}, {}]);

    //COMPOSICION
    bodyReport.push([
      this.createColumn('IMPORTES COMPOSICION', 'center', 3, true),
      {},
      {},
      this.createColumn('', 'center', 7),
      {},
      {},
      {},
      {},
      {},
      {},
    ]);
    let sumaCmpClaseA: number = 0;
    let sumaCmpClaseB: number = 0;
    let sumaCmpClaseBP: number = 0;
    let sumaCmpClaseC: number = 0;
    let sumaCmpTotal: number = 0;
    composicion.forEach((item: any) => {
      sumaCmpClaseA = sumaCmpClaseA + item.impClaseA;
      sumaCmpClaseB = sumaCmpClaseB + item.impClaseB;
      sumaCmpClaseBP = sumaCmpClaseBP + item.impClaseBPrima;
      sumaCmpClaseC = sumaCmpClaseC + item.impClaseC;

      bodyReport.push([
        this.createColumn(item.composicion, 'left', 3),
        {},
        {},
        this.createColumn(this.formatNumber(item.promedio, 2), 'right'),
        this.createColumn(this.formatNumber(item.impClaseA, 2), 'right'),
        this.createColumn(this.formatNumber(item.impClaseB, 2), 'right'),
        this.createColumn(this.formatNumber(item.impClaseBPrima, 2), 'right'),
        this.createColumn(this.formatNumber(item.impClaseC, 2), 'right'),
        this.createColumn('', 'right'),
        this.createColumn(this.formatNumber(item.suma, 2), 'right'),
      ]);
    });
    sumaCmpTotal =
      sumaCmpClaseA + sumaCmpClaseB + sumaCmpClaseBP + sumaCmpClaseC;
    sumaImporteExcedente = sumaEntExcede * preciosXLitro.excessPrice;

    bodyReport.push([
      this.createColumn('SUMA', 'left', 3),
      {},
      {},
      {},
      this.createColumn(this.formatNumber(sumaCmpClaseA, 2), 'right'),
      this.createColumn(this.formatNumber(sumaCmpClaseB, 2), 'right'),
      this.createColumn(this.formatNumber(sumaCmpClaseBP, 2), 'right'),
      this.createColumn(this.formatNumber(sumaCmpClaseC, 2), 'right'),

      sumaImporteExcedente !== 0
        ? this.createColumn(this.formatNumber(sumaImporteExcedente, 2), 'right')
        : {},

      this.createColumn(
        this.formatNumber(sumaCmpTotal + sumaImporteExcedente, 2),
        'right'
      ),
    ]);
    bodyReport.push([{}, {}, {}, {}, {}, {}, {}, {}, {}, {}]);

    bodyReport.push([
      this.createColumn2(
        '________________________________________________________________________________________________________________________________________________________________________________',
        'normal',
        10
      ),
    ]);
    bodyReport.push([{}, {}, {}, {}, {}, {}, {}, {}, {}, {}]);

    //PREMIOS
    bodyReport.push([
      this.createColumn('* * * PREMIOS * * *', 'center', 3, true),
      {},
      {},
      this.createColumn('INDICE', 'right', 0, true),
      this.createColumn('', 'center', 6),
      {},
      {},
      {},
      {},
      {},
    ]);

    bodyReport.push([{}, {}, {}, {}, {}, {}, {}, {}, {}, {}]);

    let sumaPremioA: number = 0;
    let sumaPremioB: number = 0;
    let sumaPremioBP: number = 0;
    let sumaPremioC: number = 0;
    let sumaPremioTotal: number = 0;
    premios.forEach((premio: any) => {
      const sumatoria: number =
        premio.impClaseA +
        premio.impClaseB +
        premio.impClaseBPrima +
        premio.impClaseC;
      sumaPremioA = sumaPremioA + premio.impClaseA;
      sumaPremioB = sumaPremioB + premio.impClaseB;
      sumaPremioBP = sumaPremioBP + premio.impClaseBPrima;
      sumaPremioC = sumaPremioC + premio.impClaseC;
      sumaPremioTotal = sumaPremioTotal + sumatoria;

      bodyReport.push([
        this.createColumn(premio.premio, 'left', 3),
        {},
        {},
        this.createColumn(this.formatNumber(premio.promedio, 5), 'right'),

        premio.impClaseA !== null
          ? this.createColumn(this.formatNumber(premio.impClaseA, 2), 'right')
          : {},
        premio.impClaseB !== null
          ? this.createColumn(this.formatNumber(premio.impClaseB, 2), 'right')
          : {},
        premio.impClaseBPrima !== null
          ? this.createColumn(
              this.formatNumber(premio.impClaseBPrima, 2),
              'right'
            )
          : {},
        premio.impClaseC !== null
          ? this.createColumn(this.formatNumber(premio.impClaseC, 2), 'right')
          : {},

        this.createColumn('', 'right'),
        this.createColumn(this.formatNumber(sumatoria, 2), 'right'),
      ]);
    });

    bodyReport.push([{}, {}, {}, {}, {}, {}, {}, {}, {}, {}]);

    bodyReport.push([
      this.createColumn('SUMA', 'center', 3),
      {},
      {},
      {},
      this.createColumn(this.formatNumber(sumaPremioA), 'right'),
      this.createColumn(this.formatNumber(sumaPremioB), 'right'),
      this.createColumn(this.formatNumber(sumaPremioBP), 'right'),
      this.createColumn(this.formatNumber(sumaPremioC), 'right'),
      this.createColumn('', 'right'),
      this.createColumn(this.formatNumber(sumaPremioTotal), 'right'),
    ]);

    var sumImpTotalLecheEntrega =
      sumaCmpClaseA +
      sumaPremioA +
      (sumaCmpClaseB + sumaPremioB) +
      (sumaCmpClaseBP + sumaPremioBP) +
      (sumaCmpClaseC + sumaPremioC) +
      sumaImporteExcedente;

    bodyReport.push([
      this.createColumn('IMPORTE TOTAL LECHE ENTREGADA', 'center', 3),
      {},
      {},
      {},
      this.createColumn(
        this.formatNumber(sumaCmpClaseA + sumaPremioA, 2),
        'right'
      ),
      this.createColumn(
        this.formatNumber(sumaCmpClaseB + sumaPremioB, 2),
        'right'
      ),
      this.createColumn(
        this.formatNumber(sumaCmpClaseBP + sumaPremioBP, 2),
        'right'
      ),
      this.createColumn(
        this.formatNumber(sumaCmpClaseC + sumaPremioC, 2),
        'right'
      ),
      sumaImporteExcedente !== 0
        ? this.createColumn(this.formatNumber(sumaImporteExcedente, 2), 'right')
        : {},

      this.createColumn(this.formatNumber(sumImpTotalLecheEntrega, 2), 'right'),
    ]);

    const costoTotalClaseA: number = preciosXLitro.classPriceA;
    const costoTotalClaseB: number = preciosXLitro.classPriceB;
    const costoTotalClaseBP: number = preciosXLitro.classPriceBPlus;
    const costoTotalClaseC: number = preciosXLitro.classPriceC;
    const costoTotalExcede: number = preciosXLitro.excessPrice;
    const costoTotalLitro: number =
      (costoTotalClaseA +
        costoTotalClaseB +
        costoTotalClaseBP +
        costoTotalClaseC) /
      sumaEntregaTotal;
    var divExceLts: number = sumaImporteExcedente / ltsEClaseExc;

    if (isNaN(divExceLts)) {
      divExceLts = 0;
    }

    bodyReport.push([
      this.createColumn('$/LT.', 'center', 3),
      {},
      {},
      {},
      this.createColumn(
        this.formatNumber((sumaCmpClaseA + sumaPremioA) / ltsEClaseA, 5),
        'right'
      ),
      this.createColumn(
        this.formatNumber((sumaCmpClaseB + sumaPremioB) / ltsEClaseB, 5),
        'right'
      ),
      this.createColumn(
        this.formatNumber((sumaCmpClaseBP + sumaPremioBP) / ltsEClaseBP, 5),
        'right'
      ),
      this.createColumn(
        this.formatNumber((sumaCmpClaseC + sumaPremioC) / ltsEClaseC, 5),
        'right'
      ),
      divExceLts !== 0
        ? this.createColumn(this.formatNumber(divExceLts, 2), 'right')
        : {},

      this.createColumn(
        this.formatNumber(sumImpTotalLecheEntrega / ltsEClaseSuma, 5),
        'right'
      ),
    ]);
    bodyReport.push([{}, {}, {}, {}, {}, {}, {}, {}, {}, {}]);

    bodyReport.push([
      this.createColumn2(
        '________________________________________________________________________________________________________________________________________________________________________________',
        'normal',
        10
      ),
    ]);
    bodyReport.push([{}, {}, {}, {}, {}, {}, {}, {}, {}, {}]);

    //PERCEPCIONES
    bodyReport.push([
      this.createColumn('* * * PERCEPCIONES * * *', 'center', 3, true),
      {},
      {},
      this.createColumn('LITROS', 'right'),
      this.createColumn('VALOR LT.', 'right'),
      this.createColumn('', 'center', 4),
      {},
      {},
      {},
      this.createColumn('', 'center'),
    ]);

    bodyReport.push([{}, {}, {}, {}, {}, {}, {}, {}, {}, {}]);

    let totalP077: number = 0;
    let totalP109: number = 0;
    percepciones.forEach((perDeduc: any) => {
      if (perDeduc.nombre.includes('P077') && perDeduc.tipo != null) {
        totalP077 = perDeduc.litros * perDeduc.valorLitro;

        bodyReport.push([
          this.createColumn(perDeduc.nombre, 'left', 3),
          {},
          {},
          this.createColumn(perDeduc.litros, 'right'),
          this.createColumn(this.formatNumber(perDeduc.valorLitro, 2), 'right'),
          this.createColumn('', 'right', 4),
          {},
          {},
          {},
          this.createColumn(this.formatNumber(totalP077, 2), 'right'),
        ]);
        sumImpTotalLecheEntrega += totalP077;
      }
      if (perDeduc.nombre.includes('P109') && perDeduc.nombre != null) {
        totalP109 = perDeduc.resultado;
        bodyReport.push([
          this.createColumn(perDeduc.nombre, 'left', 3),
          {},
          {},
          {},
          {},
          this.createColumn('', 'right', 4),
          {},
          {},
          {},
          this.createColumn(this.formatNumber(totalP109, 2), 'right'),
        ]);
        sumImpTotalLecheEntrega += totalP109;
      }
    });
    const filtroPercepciones = percepciones.filter((perDeduc: any) => {
      return !(
        perDeduc.nombre.includes('D508') ||
        (perDeduc.nombre.includes('D510') && perDeduc.tipo != null) ||
        (perDeduc.nombre.includes('D443') && perDeduc.nombre != null) ||
        (perDeduc.nombre.includes('P109') && perDeduc.nombre != null) ||
        (perDeduc.nombre.includes('P077') && perDeduc.nombre != null)
      );
    });

    filtroPercepciones.forEach((perDeduc: any) => {
      if (perDeduc.tipo == 'P') {
        bodyReport.push([
          this.createColumn(perDeduc.nombre, 'left', 3),
          {},
          {},
          this.createColumn('', 'right'),
          this.createColumn('', 'right'),
          this.createColumn('', 'center', 4),
          {},
          {},
          {},
          this.createColumn(this.formatNumber(perDeduc.litros, 2), 'right'),
        ]);
        sumImpTotalLecheEntrega += perDeduc.litros;
      }
    });

    bodyReport.push([{}, {}, {}, {}, {}, {}, {}, {}, {}, {}]);

    bodyReport.push([
      this.createColumn('* * * TOTAL * * *', 'left', 3, true),
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      this.createColumn(this.formatNumber(sumImpTotalLecheEntrega, 2), 'right'),
    ]);

    bodyReport.push([
      this.createColumn2(
        '________________________________________________________________________________________________________________________________________________________________________________',
        'normal',
        10
      ),
    ]);
    bodyReport.push([{}, {}, {}, {}, {}, {}, {}, {}, {}, {}]);

    //DEDUCCIONES
    bodyReport.push([
      this.createColumn('* * * DEDUCCIONES * * *', 'center', 3, true),
      {},
      {},
      this.createColumn('LITROS', 'right'),
      this.createColumn('VALOR LT.', 'right'),
      this.createColumn('', 'center', 4),
      {},
      {},
      {},
      this.createColumn('', 'center'),
    ]);

    bodyReport.push([{}, {}, {}, {}, {}, {}, {}, {}, {}, {}]);

    let totalDeducciones: number = 0;
    percepciones.forEach((perDeduc: any) => {
      if (
        perDeduc.nombre.includes('D508') ||
        (perDeduc.nombre.includes('D510') && perDeduc.tipo != null)
      ) {
        totalDeducciones =
          totalDeducciones + perDeduc.litros * perDeduc.valorLitro;

        bodyReport.push([
          this.createColumn(perDeduc.nombre, 'left', 3),
          {},
          {},
          this.createColumn(this.formatNumber(perDeduc.litros, 0), 'right'),
          this.createColumn(
            this.formatNumber(perDeduc.valorLitro * -1, 2),
            'right'
          ),
          this.createColumn('', 'center', 4),
          {},
          {},
          {},
          this.createColumn(
            this.formatNumber(perDeduc.litros * (perDeduc.valorLitro * -1), 2),
            'right'
          ),
        ]);
        sumImpTotalLecheEntrega -= totalDeducciones;
      }
      if (perDeduc.nombre.includes('D443') && perDeduc.nombre != null) {
        totalDeducciones = perDeduc.litros;

        bodyReport.push([
          this.createColumn(perDeduc.nombre, 'left', 3),
          {},
          {},
          {},
          {},
          this.createColumn('', 'center', 4),
          {},
          {},
          {},
          this.createColumn(this.formatNumber(perDeduc.litros, 2), 'right'),
        ]);
        sumImpTotalLecheEntrega -= perDeduc.litros;
      }
    });
    //TOTAL DEDUCCIONES
    bodyReport.push([
      this.createColumn('* * * TOTAL * * *', 'left', 3, true),
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      this.createColumn(this.formatNumber(totalDeducciones, 2), 'right'),
    ]);

    bodyReport.push([{}, {}, {}, {}, {}, {}, {}, {}, {}, {}]);

    const impTotalLiqLeche = sumImpTotalLecheEntrega - totalDeducciones;

    bodyReport.push([
      this.createColumn('IMPORTE TOTAL LIQUIDACION DE LECHE', 'center', 3),
      {},
      {},
      this.createColumn('', 'center', 6),
      {},
      {},
      {},
      {},
      {},
      this.createColumn(this.formatNumber(sumImpTotalLecheEntrega), 'right'),
    ]);

    bodyReport.push([
      this.createColumn('$/LT.', 'center', 3),
      {},
      {},
      this.createColumn('', 'center', 6),
      {},
      {},
      {},
      {},
      {},
      this.createColumn(
        this.formatNumber(
          (sumImpTotalLecheEntrega - totalDeducciones) / sumaEntregaTotal,
          5
        ),
        'right'
      ),
    ]);

    bodyReport.push([
      this.createColumn2(
        '________________________________________________________________________________________________________________________________________________________________________________',
        'normal',
        10
      ),
    ]);
    bodyReport.push([{}, {}, {}, {}, {}, {}, {}, {}, {}, {}]);
    //OTRAS DEDUCCIONES
    let totalOtrasDeducciones: number = 0;
    // Después del bucle forEach, agregas elementos que no cumplen las condiciones anteriores.
    const elementosNoCumplenCondiciones = percepciones.filter(
      (perDeduc: any) => {
        return !(
          perDeduc.nombre.includes('D508') ||
          (perDeduc.nombre.includes('D510') && perDeduc.tipo != null) ||
          (perDeduc.nombre.includes('D443') && perDeduc.nombre != null) ||
          (perDeduc.nombre.includes('P109') && perDeduc.nombre != null) ||
          (perDeduc.nombre.includes('P077') && perDeduc.nombre != null)
        );
      }
    );
    elementosNoCumplenCondiciones.forEach((perDeduc: any) => {
      if (perDeduc.tipo == 'D') {
        bodyReport.push([
          this.createColumn(perDeduc.nombre, 'left', 3),
          {},
          {},
          this.createColumn('', 'right'),
          this.createColumn('', 'right'),
          this.createColumn('', 'center', 4),
          {},
          {},
          {},
          this.createColumn(this.formatNumber(perDeduc.litros, 2), 'right'),
        ]);
        sumImpTotalLecheEntrega -= perDeduc.litros;
        totalOtrasDeducciones += perDeduc.litros;
      }
    });
    //TOTAL OTRAS DEDUCCIONES
    bodyReport.push([
      this.createColumn('* * * TOTAL * * *', 'left', 3, true),
      {},
      {},
      this.createColumn('', 'center', 6),
      {},
      {},
      {},
      {},
      {},
      this.createColumn(this.formatNumber(totalOtrasDeducciones), 'right'),
    ]); //SUMA DERIVADOS + SEGURO (135)

    bodyReport.push([{}, {}, {}, {}, {}, {}, {}, {}, {}, {}]);

    bodyReport.push([
      this.createColumn('* * * NETO A PAGAR * * * ------>', 'left', 3, true),
      {},
      {},
      this.createColumn('', 'center', 6),
      {},
      {},
      {},
      {},
      {},
      this.createColumn(this.formatNumber(sumImpTotalLecheEntrega), 'right'),
    ]); //(IMPORTE TOTAL LIQUIDACIÓN DE LECHE ) - 135

    bodyReport.push([
      {},
      {},
      {},
      {},
      this.createColumn('AUTORIZADO', 'right'),
      this.createColumn('ENTREGADO', 'right'),
      this.createColumn('%', 'center'),
      {},
      {},
      {},
    ]);
    for (let index = 0; index < 55; index++) {
      bodyReport.push([{}, {}, {}, {}, {}, {}, {}, {}, {}, {}]);
    }
    return bodyReport;
  }

  createColumn(
    value: string,
    align: string,
    colspan: number = 0,
    bold: boolean = false,
    size: number = 6.5
  ) {
    return {
      text: value,
      alignment: align,
      bold: bold,
      colSpan: colspan,
      fontSize: size,
      margin: [-1, -1, -1, -1],
    };
  }
  createColumn2(
    value: string,
    align: string,
    colspan: number = 0,
    bold: boolean = false,
    size: number = 6.5
  ) {
    return {
      text: value,
      alignment: align,
      bold: bold,
      colSpan: colspan,
      color: 'blue',
      fontSize: size,
      margin: [-1, -1, -1, -1],
    };
  }
  formatNumber(value: number, decimals: number = 2) {
    if (
      isNaN(value) ||
      value == undefined ||
      value == null ||
      value == Infinity
    ) {
      value = 0.0;
    }
    let left = value
      .toFixed(decimals)
      .toString()
      .split('.')[0]
      .replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,');
    let rigth = value.toFixed(decimals).toString().split('.')[1];

    if (rigth == undefined) rigth = '';
    else rigth = '.' + rigth;

    return left + rigth;
  }
  formatNumber1(value: number) {
    if (
      isNaN(value) ||
      value == undefined ||
      value == null ||
      value == Infinity
    ) {
      value = 0.0;
    }
    let left = value
      .toFixed(0)
      .toString()
      .split('.')[0]
      .replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,');
    return left;
  }
  calculateSum(values: Array<number>) {
    let sumaFinal: number = 0;
    values.forEach((item: any) => {
      sumaFinal = sumaFinal + item;
    });
    return sumaFinal;
  }

  getRowExcel(
    col1: any = null,
    col2: any = null,
    col3: any = null,
    col4: any = null,
    col5: any = null,
    col6: any = null,
    col7: any = null,
    col8: any = null,
    col9: any = null,
    col10: any = null
  ) {
    let row: Array<any> = [
      col1,
      col2,
      col3,
      col4,
      col5,
      col6,
      col7,
      col8,
      col9,
      col10,
    ];
    return row;
  }

  exportPdfToExcel(rowPdf: Array<any>) {
    let toXls: Array<any> = [];

    rowPdf.forEach((cols: Array<any>) => {
      let rowXls: Array<any> = [];
      cols.forEach((col: any) => {
        if (col.text == undefined) {
          rowXls.push(null);
        } else {
          if (this.convertirANumero(col.text)) {
            rowXls.push(this.convertirANumero(col.text));
          } else {
            rowXls.push(col.text);
          }
        }
      });
      toXls.push(rowXls);
    });
    return toXls;
  }

  async crearXls(datas: any, fechasSemana: any, selectedSemana: any) {
    var folio = 1;
    for (let i = 0; i < datas.length; i++) {
      var numSoc = datas[i].socio.partnerNumber;
      datas[i] = {
        ...datas[i],
        numSocio: numSoc,
        folio: i + 1,
      };
    }

    for (let i = 0; i < datas.length; i++) {
      var numSoc = datas[i].socio.partnerNumber;
      datas[i] = {
        ...datas[i],
        folio: i + 1,
      };
    }

    const workbook = new Workbook();
    datas.forEach((data: any) => {
      var currentPartner = data.socio.partnerName;
      var numberPartner = data.socio.partnerNumber;
      var worksheet = workbook.addWorksheet(
        this.quitarCaracteresEspeciales(numberPartner + '_' + currentPartner)
      );
      worksheet.addRow(
        this.getRowExcel(
          'GANADEROS PRODUCTORES DE LECHE PURA, S. A. P. I. DE C. V.'
        )
      );

      worksheet.addRow(
        this.getRowExcel(
          'KM. 37.4 AUTOPISTA MÉXICO-QUERÉTARO PARQUE INDUSTRIAL CUAMATLA'
        )
      );
      worksheet.addRow(
        this.getRowExcel('CUAUTITLAN IZCALLI ESTADO DE MÉXICO, TEL. 899-20-00')
      );
      worksheet.addRow(this.getRowExcel('RFC. GPL-860521-FW8'));

      const rowsExcel = this.exportPdfToExcel(
        this.createRows(
          data,
          data.socio,
          fechasSemana,
          selectedSemana,
          data.folio
        )
      );

      let entroAPercDeduc = false;
      for (let index = 0; index < rowsExcel.length; index++) {
        const rowData = rowsExcel[index];
        const row = worksheet.addRow(rowData);
        switch (rowData[0]) {
          case 'LUNES':
          case 'MARTES':
          case 'MIÉRCOLES':
          case 'MIERCOLES':
          case 'JUEVES':
          case 'VIERNES':
          case 'SÁBADO':
          case 'SABADO':
          case 'DOMINGO':
          case '* * * TOTAL * * *':
            row.getCell(3).numFmt = '#,###';
            break;
          case 'VOLUMEN LITROS AUTORIZADOS':
          case 'VOLUMEN LITROS ENTREGADOS':
            row.getCell(5).numFmt = '#,###';
            row.getCell(6).numFmt = '#,###';
            row.getCell(7).numFmt = '#,###';
            row.getCell(8).numFmt = '#,###';
            row.getCell(9).numFmt = '#,###';
            row.getCell(10).numFmt = '#,###';
            break;
          case 'GRASA':
          case 'PROTEINA':
          case 'OTROS SOLIDOS':
          case 'SUMA':
            row.getCell(4).numFmt = '#,##0.00';
            row.getCell(5).numFmt = '$#,##0.00';
            row.getCell(6).numFmt = '$#,##0.00';
            row.getCell(7).numFmt = '$#,##0.00';
            row.getCell(8).numFmt = '$#,##0.00';
            row.getCell(9).numFmt = '$#,##0.00';
            row.getCell(10).numFmt = '$#,##0.00';
            break;
          case 'LIMPIEZA':
          case 'LPC TERMODURICOS':
          case 'COLIFORMES':
          case 'CELULAS SOMATICAS':
          case 'SANIDAD ANIMAL':
          case 'BUENAS PRACTICAS PEC':
          case 'PREMIO POR ESTIMULO':
          case 'PREMIO DE LEALTAD Y CONTINUIDAD':
          case 'BIENESTAR ANIMAL':
          case 'IMPORTE TOTAL LECHE ENTREGADA':
            row.getCell(4).numFmt = '#,##0.0000';
            row.getCell(5).numFmt = '$#,##0.00';
            row.getCell(6).numFmt = '$#,##0.00';
            row.getCell(7).numFmt = '$#,##0.00';
            row.getCell(8).numFmt = '$#,##0.00';
            row.getCell(9).numFmt = '$#,##0.00';
            row.getCell(10).numFmt = '$#,##0.00';
            break;
          case '$/LT.':
            row.getCell(5).numFmt = '$#,##0.0000';
            row.getCell(6).numFmt = '$#,##0.0000';
            row.getCell(7).numFmt = '$#,##0.0000';
            row.getCell(8).numFmt = '$#,##0.0000';
            row.getCell(9).numFmt = '$#,##0.0000';
            row.getCell(10).numFmt = '$#,##0.0000';
            break;
          case '* * * PERCEPCIONES * * *':
          case '* * * DEDUCCIONES * * *':
            entroAPercDeduc = true;
        }

        if (entroAPercDeduc) {
          switch (rowData[0]) {
            case '* * * % CUMPLIMIENTO CONTRATO * * *':
              row.getCell(5).numFmt = '#,##0';
              row.getCell(6).numFmt = '#,##0';

              break;
            default:
              row.getCell(4).numFmt = '#,##0.00';
              row.getCell(5).numFmt = '$#,##0.00';
              row.getCell(10).numFmt = '$#,##0.00';
              break;
          }
        }
      }

      worksheet.getColumn(1).width = 12;
      worksheet.getColumn(2).width = 12;
      worksheet.getColumn(3).width = 12;
      worksheet.getColumn(4).width = 12;
      worksheet.getColumn(5).width = 12;
      worksheet.getColumn(6).width = 12;
      worksheet.getColumn(7).width = 12;
      worksheet.getColumn(8).width = 12;
      worksheet.getColumn(9).width = 12;
      worksheet.getColumn(10).width = 12;

      worksheet.mergeCells('A1:I1');
      worksheet.getCell('A1').alignment = { horizontal: 'center' };

      worksheet.mergeCells('A2:I2');
      worksheet.getCell('A2').alignment = { horizontal: 'center' };

      worksheet.mergeCells('A3:I3');
      worksheet.getCell('A3').alignment = { horizontal: 'center' };

      worksheet.mergeCells('A4:I4');
      worksheet.getCell('A4').alignment = { horizontal: 'center' };

      worksheet.mergeCells('A6:I6');
      worksheet.getCell('A6').alignment = { horizontal: 'center' };
    });

    const buffer = await workbook.xlsx.writeBuffer();

    var blob = new Blob([buffer], {
      type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    });

    fs.saveAs(blob, 'Reporte de Liquidación.xlsx');
  }

  formatDate(date: any) {
    const dia = ('0' + date.getDate()).slice(-2);
    const mes = ('0' + (date.getMonth() + 1)).slice(-2);
    const año = date.getFullYear();
    return `${dia}/${mes}/${año}`;
  }

  quitarCaracteresEspeciales(texto: string): string {
    // Define la expresión regular para encontrar caracteres especiales
    const regex = /[^\w\s]/gi;
    // Reemplaza los caracteres especiales con una cadena vacía
    return texto.replace(regex, '');
  }

  convertirANumero(texto: string): number | null {
    try {
      const numero = parseFloat(texto.replace(/,/g, '')); // Eliminar comas si las hay

      if (!isNaN(numero)) {
        return numero;
      } else {
        return null;
      }
    } catch (e) {
      return null;
    }
  }
}
